export default "__VITE_ASSET__BcwL7iBV__"